import React from "react";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Eyebrow } from "../../components/ui";
import { RegistrationDraftStore } from "../../store/store";
import { tokens } from "../../styles/tokens";
import {
  REGISTER_STEPS,
  firstIncompleteStep,
  stepIndexForPath,
} from "./steps";

/**
 * Shared shell for the registration wizard: progress, and the guard that keeps
 * a step from rendering without its prerequisites.
 */
export default function RegisterLayout() {
  const { pathname } = useLocation();
  const draft = RegistrationDraftStore((state) => ({
    artomeSerialNo: state.artomeSerialNo,
    epsonSerialNo: state.epsonSerialNo,
    productName: state.productName,
    ownerCompanyName: state.ownerCompanyName,
  }));

  const activeStep = stepIndexForPath(pathname);

  // Unknown child path, or a step reached without its prerequisites.
  if (activeStep === -1 || !REGISTER_STEPS[activeStep].requires(draft)) {
    return <Navigate to={firstIncompleteStep(draft).path} replace />;
  }

  return (
    <Box
      sx={{
        width: `min(100%, 760px)`,
        mx: "auto",
        px: { mobile: 2.5, tablet: 4 },
        py: { mobile: 4, laptop: 6 },
      }}
    >
      <Eyebrow>Warranty registration</Eyebrow>
      <Typography variant="h2" sx={{ mb: 4 }}>
        Register a product.
      </Typography>

      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          mb: 4,
          p: 2,
          bgcolor: "background.paper",
          border: `1px solid ${tokens.color.hairline}`,
          borderRadius: `${tokens.radius.card}px`,
        }}
      >
        {REGISTER_STEPS.map((step) => (
          <Step key={step.path}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Outlet />
    </Box>
  );
}
